export const InterludeEventTypes = {
  ADD_INTERLUDE_REQUESTED: "ADD_INTERLUDE_REQUESTED",
  INTERLUDE_ADDED: "INTERLUDE_ADDED",

  REMOVE_INTERLUDE_REQUESTED: "REMOVE_INTERLUDE_REQUESTED",
  INTERLUDE_REMOVED: "INTERLUDE_REMOVED",
};
